import { FC } from 'react';
import { Box, css, Typography } from '@mui/material';

import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';

import type { OptionType } from './types';

export const Select: FC<OptionType> = ({
    value,
    title,
    subtitle,
    onClick = () => {},
    isSelected = false,
    id,
}) => {
    const { theme, isHosTheme } = getTheme();
    const activeColor = isHosTheme ? theme.palette.secondary.dark : theme.palette.text.primary;
    const subtitleColorHos = isSelected ? theme.palette.common.white : theme.palette.secondary.dark;

    return (
        <Box
            css={styles.container}
            key={value}
            onClick={onClick}
            bgcolor={isSelected ? activeColor : theme.palette.common.white}
            {...(id && { id })}
        >
            <Typography
                variant="h3"
                color={isSelected ? theme.palette.common.white : theme.palette.text.primary}
                {...(isHosTheme && {
                    css: css({
                        fontWeight: 700,
                        color: isSelected ? theme.palette.common.white : activeColor,
                    }),
                })}
            >
                {title}
            </Typography>
            <Typography
                variant="h4"
                color={isHosTheme ? subtitleColorHos : theme.palette.text.secondary}
                {...(isHosTheme && {
                    css: css({
                        fontSize: '15px',
                        color: isSelected ? theme.palette.common.white : activeColor,
                    }),
                })}
            >
                {subtitle}
            </Typography>
        </Box>
    );
};
